import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/test/table';
import Container from '../../containers/dashboard';
import Root from '../../components/root';

export default function Test() {
  return (
    <Root title={PAGE_TITLE.TEST}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
